export { default } from './BaseUGCEditor';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/UGCEditors/BaseUGCEditor/index.js